import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import {Button, SxProps, Theme} from '@mui/material';

import {WalkthroughId} from './types';
import {useWalkthrough} from './useWalkthrough';
import {FeatureFlagContext} from '../../contexts/FeatureFlagContext/FeatureFlagContext';
import {greenColors} from '../../layouts/theme/designSystem';

interface Props {
  walkthroughId: WalkthroughId;
  sx?: SxProps<Theme>;
}

export const WalkthroughTrigger = ({walkthroughId, sx}: Props) => {
  const {t} = useTranslation();
  const {restart} = useWalkthrough();
  const {flags} = useContext(FeatureFlagContext);

  if (!flags.WALKTHROUGHS_ENABLED) return null;

  return (
    <Button
      variant='contained'
      size='small'
      disableElevation
      startIcon={<HelpOutlineIcon fontSize='small' />}
      onClick={() => restart(walkthroughId)}
      sx={{
        textTransform: 'none',
        color: 'white',
        bgcolor: greenColors[700],
        fontWeight: 600,
        borderRadius: '8px',
        px: 2,
        py: 0.75,
        whiteSpace: 'nowrap',
        boxShadow: 'none',
        '&:hover': {bgcolor: greenColors[100], boxShadow: 'none'},
        ...sx,
      }}
    >
      {t('walkthrough.trigger.label')}
    </Button>
  );
};
